"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MallocSdk = void 0;
const malloc_json_1 = __importDefault(require("./idls/malloc.json"));
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const tx_compiler_1 = require("./tx-compiler");
const cleanup_1 = require("./tx-compiler/cleanup");
const runner_1 = require("./runner");
const builder_1 = require("./builder");
const error_1 = require("./error");
class MallocSdk {
    constructor(_MALLOC_PROGRAM_ID, provider, cluster) {
        this.provider = provider;
        this.cluster = cluster;
        this.MALLOC_PROGRAM_ID = new web3_js_1.PublicKey(_MALLOC_PROGRAM_ID);
        this.mallocProgram = new anchor_1.Program(malloc_json_1.default, this.MALLOC_PROGRAM_ID, provider);
    }
    buildWithFill(nonspecific, buildActionMap, buildCompileOpts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const ret = yield (0, builder_1.buildConstructionFromNonSpecificWithFilled)(nonspecific, buildActionMap, this.provider, { cluster: this.cluster }, {
                authority: (_a = buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.authority) === null || _a === void 0 ? void 0 : _a.publicKey,
                preferredTokenAccounts: buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.preferredTokenAccounts,
            });
            return {
                constructionBuilt: ret.constructionBuilt,
                filledNonSpecific: (0, builder_1.nspFilledUnserialToSerial)(ret.filledNonSpecific),
            };
        });
    }
    build(nonspecific, buildActionMap, buildCompileOpts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, builder_1.buildConstructionFromNonSpecific)(nonspecific, buildActionMap, this.provider, { cluster: this.cluster }, {
                authority: (_a = buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.authority) === null || _a === void 0 ? void 0 : _a.publicKey,
                preferredTokenAccounts: buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.preferredTokenAccounts,
            });
        });
    }
    buildCompileRun(nonspecific, inputTokenAccounts, buildActionMap, buildCompileOpts, runOpts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const builtConstruction = yield (0, builder_1.buildConstructionFromNonSpecific)(nonspecific, buildActionMap, this.provider, { cluster: this.cluster }, {
                authority: (_a = buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.authority) === null || _a === void 0 ? void 0 : _a.publicKey,
                preferredTokenAccounts: buildCompileOpts === null || buildCompileOpts === void 0 ? void 0 : buildCompileOpts.preferredTokenAccounts,
            });
            console.log("construction built");
            const compiled = yield this.compileConstruction({
                construction: builtConstruction,
                actionMap: buildActionMap,
                amountInAccounts: inputTokenAccounts,
                opts: buildCompileOpts,
            });
            return yield this.runConstruction(compiled, runOpts);
        });
    }
    getErrorInfo(construction, error) {
        if (!error.actionIdx) {
            return {
                successful: [],
                notRan: construction.actions.map((a) => a.actionName),
            };
        }
        const idx = error.actionIdx;
        return {
            successful: construction.actions.slice(0, idx).map((a) => a.actionName),
            errored: construction.actions[idx].actionName,
            notRan: idx < construction.actions.length - 1
                ? construction.actions.slice(idx + 1).map((s) => s.actionName)
                : [],
        };
    }
    compileConstruction(inst) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, tx_compiler_1.compileConstruction)(this.provider, this.mallocProgram, inst);
        });
    }
    getConstructionState(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const constructionState = (yield this.mallocProgram.account.construction.fetch(data.constructionSigner.publicKey));
            const actionSerialize = (a) => {
                return {
                    inputTokenAccount: a.inputTokenAccount
                        ? new web3_js_1.PublicKey(a.inputTokenAccount).toBase58()
                        : undefined,
                    inDegree: a.inDegree,
                    nextNodes: a.nextNodes.map((o) => o.map((nextNode) => {
                        return {
                            actionIdx: nextNode.actionIdx,
                            fraction: new anchor_1.BN(nextNode.fraction).toString(),
                            nextInputMintIdx: nextNode.nextInputMintIdx,
                        };
                    })),
                };
            };
            const actionCallSerialize = (a) => {
                return {
                    numbTimesHit: a.numbTimesHit,
                    callAmounts: a.callAmounts.map((callAmount) => new anchor_1.BN(callAmount).toString()),
                    status: Object.keys(a.status)[0]
                };
            };
            return {
                authority: new web3_js_1.PublicKey(constructionState.authority).toBase58(),
                actions: constructionState.actions.map(actionSerialize),
                actionCalls: constructionState.actionCalls.map(actionCallSerialize),
            };
        });
    }
    /**
     * Close the ephemeral accounts such that the caller reclaims more rent then
     * is spent on the transaction of closing the account.
     *
     * As a note: this may mean that result accounts are not closed as they have next to
     * no rent
     */
    cleanup(constructionData, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const txs = yield (0, cleanup_1.cleanup)(this.provider, this.mallocProgram, constructionData.construction, constructionData.constructionSigner, constructionData.authority, options);
            try {
                yield this.provider.sendAll(txs, options === null || options === void 0 ? void 0 : options.commitment);
            }
            catch (e) {
                throw (0, error_1.newCleanupError)(e, (_b = (_a = options === null || options === void 0 ? void 0 : options.commitment) === null || _a === void 0 ? void 0 : _a.skipPreflight) !== null && _b !== void 0 ? _b : false);
            }
        });
    }
    runConstruction(construction, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, runner_1.runConstruction)(this.provider, construction, options);
        });
    }
    /**
     * Run a construction starting with the transaction for a specific action
     */
    runConstructionFromAction(construction, actionName, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, runner_1.runConstruction)(this.provider, construction, options, actionName);
        });
    }
    getEstimates(builtConstruction, actionName) {
        const action = builtConstruction.actions.find((act) => act.actionName === actionName);
        if (!action)
            throw `Could not find the action ${actionName}`;
        const mapToBN = (e) => {
            return { mint: e.mint, amount: new anchor_1.BN(e.amount) };
        };
        return {
            estimateIns: action.estimateIns.map(mapToBN),
            estimateOuts: action.estimateOuts.map(mapToBN),
        };
    }
}
exports.MallocSdk = MallocSdk;
